import { Icon } from '@chakra-ui/icons';

export const ClipboardIcon = ({ color = 'action' }: { color?: string }) => (
	<Icon
		width="17px"
		height="16px"
		viewBox="0 0 17 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M13.9092 5.83936H7.60923C6.83603 5.83936 6.20923 6.46616 6.20923 7.23936V13.5394C6.20923 14.3126 6.83603 14.9394 7.60923 14.9394H13.9092C14.6824 14.9394 15.3092 14.3126 15.3092 13.5394V7.23936C15.3092 6.46616 14.6824 5.83936 13.9092 5.83936Z"
			stroke={color}
			strokeWidth="1.6"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M3.40909 10.0395H2.70908C2.33778 10.0395 1.98168 9.89197 1.71913 9.62942C1.45658 9.36687 1.30908 9.01077 1.30908 8.63947V2.33946C1.30908 1.96815 1.45658 1.61206 1.71913 1.3495C1.98168 1.08695 2.33778 0.939453 2.70908 0.939453H9.0091C9.3804 0.939453 9.7365 1.08695 9.99905 1.3495C10.2616 1.61206 10.4091 1.96815 10.4091 2.33946V3.03946"
			stroke={color}
			strokeWidth="1.6"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</Icon>
);
